import { render, staticRenderFns } from "./PreviewProduct.vue?vue&type=template&id=dc150e26&scoped=true&"
import script from "./PreviewProduct.vue?vue&type=script&lang=js&"
export * from "./PreviewProduct.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProduct.vue?vue&type=style&index=0&id=dc150e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc150e26",
  null
  
)

component.options.__file = "PreviewProduct.vue"
export default component.exports